import IEmployee from "@/module/main/dto/customer/IEmployee";
import IContractDuration from "@/module/main/dto/customer/IContractDuration";
import IAddress from "@/module/main/dto/customer/IAddress";

export default class Employee implements IEmployee {
    constructor(
        public contractDuration?: IContractDuration,
        public employerAddresses?: [IAddress],
        public employerName?: string,
        public employerBusinessId?: string
    ) {}
}
